/**
 * Base paths for flows
 */
export const FLOWS_BASE_PATHS = {
    CREATE_CONTRACT: "/create-contract",
    CREATE_OUTCOME: "/create-outcome",
    GENERATE_BPF: "/generate-bpf",
    UPLOAD_CLAIM_FILE: "/upload-claim-file",
};

export const FLOWS_PATHS = {
    PERFORMANCE_BASED: {
        CREATE_CONTRACT: FLOWS_BASE_PATHS.CREATE_CONTRACT,
    },
    VOLUME_BASED: {
        CREATE_CONTRACT: FLOWS_BASE_PATHS.CREATE_CONTRACT,
    },
};

export const FLOW_BASE_PATH = "__FLOW_STORAGE_PATH__";
export const FLOW_FINISHED_FLAG = "__FLOW_FINISHED__";
